<template>
  <div class="w-100 address-wrapper">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form @keyup.enter.native="getTableList" class="com-search-box" ref="form" :model="form" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="关键字 :" prop="title" placeholder="请输入">
              <el-input  v-model="form.title"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="类型 :" prop="type">
              <el-select v-model="form.type" placeholder="请选择部门">
                <el-option v-for="item in departmentArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="com-head-search-btns" style="bottom: 30px;top: auto">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button  @click="resetForm">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content" style="padding-top: 0;">
      <!-- <div class="button">
        <el-row>
          <el-button class="el-primary-border" round @click="handleAdd()">
            <svg-icon icon-class="add" />&nbsp;添加联系人
          </el-button>
        </el-row>
      </div> -->
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <el-table-column  label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column  prop="name" label="姓名" min-width="8%" show-overflow-tooltip>
            <template slot-scope="scope">
              <a class="m-btn" @click="handleView(scope.row)">{{ scope.row.name }}</a>
            </template>
          </el-table-column>
          <el-table-column  prop="phone" label="联系方式" min-width="11%"></el-table-column>
          <el-table-column  prop="dept" label="所属部门" min-width="15%">
            <template slot-scope="scope">{{ filterDept(scope.row.dept) }}</template>
          </el-table-column>
          <el-table-column  prop="email" label="邮箱" min-width="15%"></el-table-column>

          <!-- 操作 -->
          <!-- <el-table-column  fixed="right" label="操作" min-width="10  %">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="handleView(scope.row)">详情</a>
              <a class="m-btn mr-10" @click="handleEdit(scope.row)">编辑</a>
              <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row)">删除</a>
            </template>
          </el-table-column> -->
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <!-- 新增 -->
    <div>
      <el-dialog :title="operation == 'add' ? '新增联系人': operation == 'edit' ? '编辑联系人':'查看联系人'" @close="onCancel" :visible.sync="dialogVisible" :width="'600px'">
        <el-form ref="form" :model="addForm" :rules="rules">
          <el-form-item class="mb-30" prop="name">
            <el-input v-model="addForm.name" :disabled="operation == 'view'" placeholder="请输入姓名" />
          </el-form-item>

          <el-form-item class="mb-30" prop="dept">
            <el-select v-model="addForm.dept" :disabled="operation == 'view'" placeholder="请选择所属部门">
              <el-option v-for="item in departmentArr" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="mb-30" prop="phone">
            <el-input v-model="addForm.phone" :disabled="operation == 'view'" placeholder="请输入手机号码" />
          </el-form-item>

          <el-form-item class="mb-30" prop="zj">
            <el-input v-model="addForm.zj" :disabled="operation == 'view'" placeholder="请输入座机号码" />
          </el-form-item>

          <el-form-item class="mb-30" prop="email">
            <el-input v-model="addForm.email" :disabled="operation == 'view'" placeholder="请输入邮箱" />
          </el-form-item>

        </el-form>
        <div class="dialog-footer tr mt-30" v-if="operation != 'view'">
          <el-button @click="onCancel">取 消</el-button>
          <el-button type="primary" @click="onSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    var checkPhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号码'));
      } else {
        if (!this.isCellPhone(value)) {
          callback(new Error("请输入正确的手机号!"));
        }
        callback();
      }
    };

    var checkEmail = (rule, value, callback) => {
      if (value == '' || value == undefined) {
        callback();
      } else {
        const reg = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
        if (!reg.test(value)) {
          callback(new Error("请输入正确的邮箱!"));
        }
        callback();
      }
    };
    return {
      form: {
        title: '',
        type: ''
      },
      rules: {
        name: [{ required: true, message: '联系人不能为空', trigger: 'blur' }],
        dept: [{ required: true, message: '所属部门不能为空', trigger: 'blur' }],
        phone: [{ validator: checkPhone, trigger: 'blur' }],
        email: [{ validator: checkEmail, trigger: 'blur' }],
      },
      departmentArr: [],
      operation: 'add',
      addForm: {},
      listLoading: false,
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      tableData: [],
      dialogVisible: false
    }
  },

  mounted() {
    this.getSelect()
    this.getData()
  },

  methods: {
    isCellPhone(val) {
      if (!/^1(3|4|5|6|7|8)\d{9}$/.test(val)) {
        return false;
      } else {
        return true;
      }
    },
    // 项目列表
    getData() {
      this.listLoading = true
      this.tableData = []
      this.$api.workbench.getAddressBookList({
        ...this.form,
        ...this.listQuery
      }).then(res => {
        this.listLoading = false
        if (res.success) {
          if (res.result && res.result.records) {
            this.tableData = res.result.records
            this.total = res.result.total
          }
        } else {
          this.$message.error(res.message)
        }
      }).catch(err => {
        this.listLoading = false
      })
    },

    filterDept(id) {
      let arr = this.departmentArr.filter(item => {
        return item.id == id
      })

      if (arr && arr.length > 0) {
        return arr[0].name
      }

      return null
    },

    // 查询下拉框
    getSelect() {
      this.$http.post('/job/employeeDict').then(res => {
        if (res.success) {
          let data = res.result
          this.departmentArr = data.department
        }
      })
    },

    // 重置查询
    resetForm() {
      this.form = {
        title: '',
        type: ''
      }
      this.listQuery.currentPage = 1
      this.getData()
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.getData()
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.getData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.getData()
    },

    onCancel() {
      this.dialogVisible = false
      this.addForm = {}
      this.$refs["form"].clearValidate()
    },

    onSubmit() {
      debugger
      const self = this
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let url = "addAddressBook"
          if (this.addForm.id) {
            url = "updateAddressBook"
          }
          this.$api.workbench[url](this.addForm).then(res => {
            if (res.success) {
              this.$message.success({
                message: this.addForm.id ? '联系人修改成功' : '新增联系人成功',
                onClose() {
                  self.dialogVisible = false
                  self.addForm = {}
                  self.getData()
                }
              })
            }
          })
        } else {
          return false;
        }
      });
    },

    // 新增
    handleAdd() {
      this.operation = "add"
      this.dialogVisible = true
    },

    handleView(obj) {
      this.operation = "view"
      this.$api.workbench.getAddressBookDetail({ id: obj.id }).then(res => {
        if (res.success) {
          if (res && res.result) {
            this.dialogVisible = true
            this.addForm = res.result
          }
        }
      })
    },
    handleEdit(obj) {
      this.operation = "edit"
      this.dialogVisible = true
      this.addForm = JSON.parse(JSON.stringify(obj))
    },
    handleDelete(obj) {
      this.$common.confirm(
        {
          title: `是否确认删除？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$api.workbench.delAddressBook({ id: obj.id }).then(res => {
            if (res.success) {
              this.$message.success('删除成功')
              this.getData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    }
  },
}
</script>

<style lang="scss" scoped>
.address-wrapper {
  /deep/ .el-form-item {
    .el-select {
      width: 100%;
    }
  }
}
</style>